import axios from "axios";
import { Message } from "element-ui";
// import store from "../store/index";
import { getToken, getClientrequestid, setClientrequestid } from "@/utils/auth";
const service = axios.create({
  baseURL: "https://www.zhongseyun.com",
  timeout: 15 * 16 * 1000,
});

// Request interceptors
service.interceptors.request.use(
  (config) => {
    // Add X-Access-Token header to every request, you can add other custom headers here
    // if (UserModule.token) {
    //   config.headers['X-Access-Token'] = UserModule.token
    // }
    config.headers["X-Token-Type"] = 1;
    if (getToken()) {
      config.headers["X-Sa-Token"] = getToken();
    } else if (window.sessionStorage.getItem("X-Sa-Token")) {
      config.headers["X-Sa-Token"] =
        window.sessionStorage.getItem("X-Sa-Token");
    }
    config.headers["client-request-id"] = getClientrequestid();
    return config;
  },
  (error) => {
    Message({
      message: error.msg,
      type: "error",
      duration: 5 * 1000,
    });
    Promise.reject(error);
  }
);

// Response interceptors
service.interceptors.response.use((response) => {
  // Some example codes here:
  // code == 20000: success
  // code == 50001: invalid access token
  // code == 50002: already login in other place
  // code == 50003: access token expired
  // code == 50004: invalid user (user not exist)
  // code == 50005: username or password is incorrect
  // You can change this part for your own usage.
  if (response.headers["client-request-id"]) {
    setClientrequestid(response.headers["client-request-id"]);
  }
  if (response.config.responseType == "blob") {
    return response;
  }
  const res = response.data;
  if (res.code !== 0) {
    if (res.code === -33 || res.code === 401) {
      // store.commit("SET_STATE");
      return false;
    }
    Message({
      message: res.msg,
      type: "error",
      duration: 5 * 1000,
    });
    // return Promise.reject(new Error(res.msg || 'Error'))
    return response.data;
  } else {
    return response.data;
  }
});

export default service;
